// src/components/FeedbackButton.tsx
import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import FeedbackForm from './FeedBackForm';

interface FeedbackButtonProps {
  storeId: string;
}

const FeedbackButton: React.FC<FeedbackButtonProps> = ({ storeId }) => {
  const { t } = useLanguage();
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  
  return (
    <>
      <button
        onClick={() => setShowFeedbackForm(true)}
        className="fixed bottom-6 right-6 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-10"
        aria-label={t('features.feedback')}
      >
        <MessageSquare className="h-6 w-6" />
      </button>
      
      {showFeedbackForm && (
        <FeedbackForm 
          storeId={storeId} 
          onClose={() => setShowFeedbackForm(false)} 
        />
      )}
    </>
  );
};

export default FeedbackButton;